export default __webpack_public_path__ + "static/media/nft_card.0405d0f7.jpg";